import Vue from 'vue'
import commentMixin from './comment-mixin'
import tileMixin from 'layouts/masonry/tile-mixin'

import withRender from './callout-comment.html'
import './callout-comment.scss'

export default withRender(Vue.extend({
  mixins: [commentMixin, tileMixin],
  computed: {
    styles() {
      if (this.isTile) {
        return this.tileStyles
      }
    }
  },
  // NOTE: methods.expandComment() in commentMixin makes a call to tileMixin tileHeightChanged()
  mounted() {
    if (this.isTile) {
      // let's the masonry layout know that this tile is ready
      this.isReady = true
    }
  },
  watch: {
    tileWidth() {
      // watching for the tile width that comes from the mixin.  This is changed when the
      // layout sets the width. When changed, setting isReady to true so that the positioning
      // of the tiles gets redrawn
      if (this.isTile) {
        this.$nextTick(() => {
          this.isReady = true
        })
      }
    }
  }
}))
